import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
import { jsx as t, jsxs as e } from "react/jsx-runtime";
import { Badge as i } from "@vds-core/badges";
import { Icon as r } from "@vds-core/icons";
import { TitleLockup as o, TitleLockupEyebrow as n, TitleLockupTitle as a, TitleLockupSubtitle as l } from "@vds-core/type-lockups";
import { withVDSManager as d, generateUUID as s, getNodeText as c } from "@vds-core/utilities";
import { ColorTokens as p } from "@vds-tokens/color";
import { Component as u } from "react";
import h from "styled-components";
import m from "../utils/calculateLineClamps.js";
import g from "./TileContainer.js";
var f = h.div.withConfig({
    displayName: "InsideContainerScaleWrapper",
    componentId: "VDS__sc-13q0eoq-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  ", ";\n  border-radius: 12px;\n"])), function (_ref) {
    var t = _ref.width;
    return t;
  }, function (_ref2) {
    var t = _ref2.height;
    return "100%" === t ? "height: 100%" : "";
  }),
  x = h.div.withConfig({
    displayName: "TileletContainer",
    componentId: "VDS__sc-13q0eoq-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"]))),
  b = h.div.withConfig({
    displayName: "TitleLockupContainer",
    componentId: "VDS__sc-13q0eoq-2"
  })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  max-height: 100%;\n\n  width: ", ";\n  padding-bottom: ", ";\n"])), function (_ref3) {
    var t = _ref3.$textWidth;
    return t;
  }, function (_ref4) {
    var t = _ref4.$titleLockupBottomPadding;
    return t;
  }),
  v = h.div.withConfig({
    displayName: "TitleLockupInsideWrapper",
    componentId: "VDS__sc-13q0eoq-3"
  })(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  height: 100%;\n  max-height: 100%;\n  text-overflow: ellipsis;\n  display: flex;\n  align-items: ", ";\n"])), function (_ref5) {
    var t = _ref5.$textPosition;
    return "bottom" === t ? "flex-end" : "middle" === t ? "center" : "flex-start";
  }),
  k = h.div.withConfig({
    displayName: "IconContainer",
    componentId: "VDS__sc-13q0eoq-4"
  })(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: ", ";\n  flex-direction: row;\n  justify-content: ", ";\n  align-items: flex-end;\n"])), function (_ref6) {
    var t = _ref6.textPosition;
    return "bottom" === t ? "none" : "flex";
  }, function (_ref7) {
    var t = _ref7.$iconPosition;
    return t;
  }),
  w = h.div.withConfig({
    displayName: "BadgeContainer",
    componentId: "VDS__sc-13q0eoq-5"
  })(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  max-width: ", ";\n  padding-bottom: 4px;\n"])), function (_ref8) {
    var t = _ref8.badgeWidth;
    return t;
  });
var y = /*#__PURE__*/function (_u) {
  _inherits(y, _u);
  function y(t) {
    var _this;
    _classCallCheck(this, y);
    var e;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(y).call(this, t)), e = _assertThisInitialized(_assertThisInitialized(_this)), _this._calculateInnerPadding = function () {
      switch (e.props.viewport) {
        case "mobile":
          return "12px" === e.props.innerPadding ? "12px" : "16px";
        case "tablet":
          return "16px" === e.props.innerPadding ? "16px" : "24px";
        default:
          return "32px" === e.props.innerPadding ? "32px" : "24px";
      }
    }, _this._calculateBottomPadding = function () {
      if (!e.props.directionalIcon && !e.props.descriptiveIcon || e.props.badge) return "0px";
      switch (e.props.innerPadding) {
        case "12px":
          return "16px";
        case "16px":
          return "24px";
        case "32px":
          return "48px";
        default:
          return "32px";
      }
    }, _this.setHover = function () {
      var t = e.state.hovered;
      e.setState({
        hovered: !t
      });
    }, _this.state = {
      hovered: !1
    }, _this.tileletId = t.id || s();
    return _this;
  }
  _createClass(y, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var t = this;
      m(this.tileletId, this._calculateBottomPadding, this.props.title, this.props.subtitle), window.addEventListener("resize", function () {
        return m(t.tileletId, t._calculateBottomPadding, t.props.title, t.props.subtitle);
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(t) {
      t.title === this.props.title && t.subtitle === this.props.subtitle || m(this.tileletId, this._calculateBottomPadding, this.props.title, this.props.subtitle);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var t = this;
      window.removeEventListener("resize", function () {
        return m(t.tileletId, t._calculateBottomPadding, t.props.title, t.props.subtitle);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        d = _this$props.eyebrow,
        s = _this$props.title,
        u = _this$props.subtitle,
        h = _this$props.descriptiveIcon,
        m = _this$props.directionalIcon,
        y = _this$props.aspectRatio,
        I = _this$props.showBorder,
        $ = _this$props.showDropShadow,
        P = _this$props.shadowStrong,
        _ = _this$props.backgroundColor,
        C = _this$props.backgroundImage,
        S = _this$props.background,
        z = _this$props.height,
        L = _this$props.width,
        q = _this$props.onClick,
        B = _this$props.imageFallbackColor,
        D = _this$props.surface,
        W = _this$props.id,
        j = _this$props.textPosition,
        N = _this$props.viewport,
        V = _this$props.innerPadding,
        M = _this$props.badge,
        T = _this$props.tabIndex,
        H = _this$props.textAlignment,
        O = _this$props.textWidth,
        A = _this$props.target,
        E = _this$props.ariaLabel,
        F = _this$props.role,
        R = _this$props.grouped,
        U = _this$props.href,
        X = _this$props["data-track"],
        G = _this$props["data-track-ignore"],
        J = _this$props["data-analyticstrack"],
        K = _this$props["data-clickstream"],
        Q = function Q(t) {
          return "titleSmall" === (s && s.size) && "titleSmall" === t ? "bodySmall" : t;
        },
        Y = d && d.children && d.children,
        Z = s && s.children ? s.children : s && s.text,
        tt = u && u.children ? u.children : u && u.text,
        et = c(Y),
        it = c(Z),
        rt = c(tt),
        ot = (at = D, "white" === (nt = _) ? p.palette.white.value : "black" === nt ? p.palette.black.value : "secondary" === nt || "gray" === nt ? p.background.secondary["".concat(at)].value : "primary" === nt ? p.background.primary["".concat(at)].value : p.background.primary.inverse["".concat(at)].value);
      var nt, at;
      var lt = "light" === D && ot === p.palette.black.value || "dark" === D && ot !== p.palette.white.value;
      return t(f, {
        width: L,
        height: z,
        children: t(g, {
          onMouseEnter: this.setHover,
          onMouseLeave: this.setHover,
          backgroundImage: C,
          backgroundColor: ot,
          aspectRatio: y,
          showBorder: I,
          showDropShadow: $,
          shadowStrong: P,
          height: z,
          width: "100%",
          onClick: q,
          imageFallbackColor: B,
          surface: D,
          padding: this._calculateInnerPadding(),
          id: this.tileletId,
          tabIndex: T,
          href: U,
          target: A,
          "data-track": X,
          "data-track-ignore": G,
          "data-analyticstrack": J,
          "data-clickstream": K,
          background: S,
          role: F,
          ariaLabel: E || (Y || Z || tt ? "".concat(M && M.children ? M.children : "", "\n              ").concat(Y ? et : "", "\n              ").concat(Z ? it : "", " ").concat(tt ? rt : "", " ") : "Tilelet"),
          grouped: R,
          children: e(x, {
            children: [M && t(w, {
              badgeWidth: M.maxWidth,
              children: t(i, Object.assign({}, M, {
                id: "tilelet-badge-".concat(this.tileletId)
              }))
            }), t(b, {
              $textWidth: O,
              $titleLockupBottomPadding: "top" !== j ? "0px" : (h || m) && this._calculateBottomPadding(),
              children: t(v, {
                $textPosition: j,
                children: e(o, {
                  viewport: N,
                  surface: lt ? "dark" : "light",
                  textAlignment: H,
                  id: "tilelet-lockup-eyebrow-".concat(this.tileletId),
                  children: [void 0 !== Y && t(n, Object.assign({}, d, {
                    size: d && Q(d.size),
                    surface: d && "dark" === d.surface || lt ? "dark" : "light",
                    id: "tilelet-eyebrow-".concat(this.tileletId),
                    children: Y
                  })), void 0 !== Z && t(a, Object.assign({}, s, {
                    size: function () {
                      var t = s && s.size;
                      var e;
                      return e = t && ["bodySmall", "bodyMedium", "bodyLarge", "titleSmall", "titleMedium", "titleLarge", "titleXLarge"].includes(t) ? t : "titleSmall", e;
                    }(),
                    primitive: s && s.primitive ? s.primitive : "p",
                    surface: s && s.surface && "dark" === s.surface || lt ? "dark" : "light",
                    id: "tilelet-title-".concat(this.tileletId),
                    children: Z
                  })), void 0 !== tt && t(l, Object.assign({}, u, {
                    size: u && Q(u.size),
                    surface: u && "dark" === u.surface || lt ? "dark" : "light",
                    id: "tilelet-subtitle-".concat(this.tileletId),
                    children: tt
                  }))]
                })
              })
            }), (h || m) && e(k, {
              id: "tilelet-icon-container-".concat(this.tileletId),
              $iconPosition: h && !m ? "flex-start" : m && !h ? "flex-end" : "space-between",
              "aria-hidden": "true",
              children: [h && !m && !M && "bottom" !== j && t(r, {
                size: h && h.size ? h.size : "medium",
                color: lt || h && "dark" === h.surface ? p.elements.primary.ondark.value : p.elements.primary.onlight.value,
                name: h && h.name ? h.name : "multiple-documents"
              }), m && !h && !M && "bottom" !== j && t(r, {
                name: "external-link" === m.name ? "external-link" : "right-arrow",
                size: function () {
                  var t = null == m ? void 0 : m.size;
                  return "mobile" === N ? "medium" === t ? "medium" : "small" : "large" === t ? "large" : "medium";
                }(),
                color: m.color ? m.color : lt || m.color || "dark" === m.surface ? p.elements.primary.ondark.value : p.elements.primary.onlight.value,
                ariaHidden: !0
              })]
            })]
          })
        })
      });
    }
  }]);
  return y;
}(u);
y.defaultProps = {
  textPosition: "top",
  textAlignment: "left",
  textWidth: "100%",
  surface: "light",
  target: "_self"
};
var I = d(y);
export { I as default };